<form class="w100" [formGroup]="formGoup">
  <mat-form-field class="w100" color="accent">
    @if (title) {
      <mat-label>{{title}}</mat-label>
    }
    <mat-chip-grid #chipGrid>
      @for (value of selectedValues$|async; track value) {
        <mat-chip-row (removed)="remove(value)"
          class="background-color-accent-important color-text-contrast-accent" style="color: white">
          {{value}}
          <button matChipRemove [attr.aria-label]="'remove ' + value">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input formControlName="currentValue"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="add()"
      />
    <button mat-icon-button type="button" color="accent" matIconSuffix
      (click)="$event.stopPropagation();clickAdd()">
      <mat-icon>add</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (possibleValue of (possibleValues$ | async); track possibleValue) {
        <mat-option [value]="possibleValue">
          {{possibleValue}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>